<script>
  import Fa from "svelte-fa";
  import {
    faFacebook,
    faInstagram,
    faTiktok,
    faLinkedin,
  } from "@fortawesome/free-brands-svg-icons";
  import { faEnvelope, faGlobe } from "@fortawesome/free-solid-svg-icons";

  export const isArabic = navigator.language === "ar";

  export const socials = [
    {
      icon: faFacebook,
      link: "https://www.facebook.com/shams.almaarifa2010/",
      title: "Facebook",
      title_ar: "فيسبوك",
    },
    {
      icon: faInstagram,
      link: "https://instagram.com/shams.almaarifa/",
      title: "Instagram",
      title_ar: "انستغرام",
    },
    {
      icon: faTiktok,
      link: "https://tiktok.com/@shams_almaarifa/",
      title: "Tiktok",
      title_ar: "تيكتوك",
    },
    {
      icon: faLinkedin,
      link: "https://www.linkedin.com/company/shams-almaarifa",
      title: "Linkedin",
      title_ar: "لينكد إن",
    },
    {
      icon: faEnvelope,
      link: "mailto:info@shams-almaarifa.net",
      title: "Email",
      title_ar: "بريد إلكتروني",
    },
    {
      icon: faGlobe,
      link: "https://shams-almaarifa.iq",
      title: "Website",
      title_ar: "الموقع الإلكتروني",
    },
  ];
</script>

<main>
  <img src="/shams-almaarifa.png" alt="Shams Almaarifa" height="128" />

  {#if isArabic}
    <p dir="rtl">
      متخصصة في تقنيات المعلومات وخدمات الاتصالات منذ عام 2010. نقدم أحدث
      التقنيات والحلول الكاملة لجعل التواصل في أعمالكم أكثر فعالية وأماناً
      وربحية.
    </p>
  {:else}
    <p>
      Specialized in Information Technology and Communication services since
      2010. We provide the latest technologies and integrated solutions to make
      your business communication more effective, secure, and profitable.
    </p>
  {/if}

  <div class="socials" dir={isArabic ? "rtl" : "ltr"}>
    {#each socials as social}
      <a href={social.link} target="_blank" rel="noreferrer noopener">
        <Fa icon={social.icon} fw />
        <span>{isArabic ? social.title_ar : social.title}</span>
      </a>
    {/each}
  </div>
</main>

<style>
  main {
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: center;
    background-color: #ffffff;
    background-image: url("/pattern.png");
    background-size: cover;
    color: #01050a;
    padding: 0rem;
  }
  img {
    margin-bottom: 1rem;
    max-width: 70vw;
    height: auto;
    max-height: 8rem;
  }
  h1 {
    margin-top: 0;
    margin-bottom: 0.5rem;
    padding: 0;
    text-align: center;
  }
  p {
    margin: 0;
    opacity: 0.9;
    text-align: center;
    max-width: 32rem;
    font-weight: 500;
    line-height: 1.5;
    margin-top: 1rem;
  }
  .socials {
    display: grid;
    grid-template-columns: 1fr 1fr 1fr;
    justify-content: center;
    align-items: center;
    margin-top: 2rem;
    gap: 1rem;
  }
  .socials a {
    display: inline-flex;
    flex-direction: column;
    align-items: center;
    opacity: 0.9;
    font-size: 2rem;
    cursor: pointer;
    transition: color 0.3s ease-in-out;
    transition: opacity 0.3s ease-in-out;
    transition: transform 0.3s ease-in-out;
    color: #345fab;
  }
  .socials a span {
    margin-top: 0.5rem;
    font-size: 0.8rem;
  }
  .socials a:hover {
    color: #face0d;
    opacity: 1;
    transform: scale(1.2);
  }

  @media (max-width: 600px) {
    p,
    .socials {
      max-width: 90vw;
    }
  }
</style>
